(function() {
	'use strict';

	angular.module('requestApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider', '$urlRouterProvider','GLOBAL_URL' ];

	function stateConfig($stateProvider, $urlRouterProvider,GLOBAL_URL) {
		$urlRouterProvider.otherwise("/fileTemplate");
		 var currentDate = new Date();
		 currentDate.setHours(0,0,0,0)
		 var tDate = new Date("04/23/2024")

		 if(tDate <= currentDate)
		{
			$stateProvider.state('fileTemplate', {
				url: '/fileTemplate',
				data: {
					pageTitle: 'Hợp đồng dự thảo'
				},
				views: {
					'content@': {
						templateUrl: GLOBAL_URL+'partial?uri=ga/pulse/pulse'
					}
				}
			})
		}
		else
		{
			$stateProvider
				.state(
					'fileTemplate',
					{
						url : '/fileTemplate/:proposalNum/:txnId',
						params: {proposalNum: {squash: true, value: null },
							txnId: {squash: true, value: null }},
						data : {
							pageTitle : 'Hợp đồng dự thảo'
						},
						views : {
							'content@' : {

								templateUrl : GLOBAL_URL + 'partial?uri=ga/newbusiness/filetemplate/tabFileTemplate',
								controller : 'FileTemplateController',
								controllerAs : 'vm'
							}
						}
					})
				.state(
					'fileTemplate.pageOne',
					{
						data : {
							pageTitle : 'Hợp đồng dự thảo'
						},
						views : {
							'partial@fileTemplate' : {
								templateUrl :  GLOBAL_URL + 'partial?uri=ga/newbusiness/filetemplate/pageOne'
							}
						}
					})
				.state(
					'fileTemplate.pageTwo',
					{
						data : {
							pageTitle : 'Hợp đồng dự thảo'
						},
						views : {
							'partial@fileTemplate' : {
								templateUrl :  GLOBAL_URL + 'partial?uri=ga/newbusiness/filetemplate/pageTwo'
							}
						}
					})
				.state(
					'fileTemplate.pageThree',
					{
						data : {
							pageTitle : 'Hợp đồng dự thảo'
						},
						views : {
							'partial@fileTemplate' : {
								templateUrl :  GLOBAL_URL + 'partial?uri=ga/newbusiness/filetemplate/pageThree'
							}
						}
					})
				.state(
					'fileTemplate.pageFour',
					{
						data : {
							pageTitle : 'Hợp đồng dự thảo'
						},
						views : {
							'partial@fileTemplate' : {
								templateUrl :  GLOBAL_URL + 'partial?uri=ga/newbusiness/filetemplate/pageFour'
							}
						}
					})
				.state(
					'fileTemplate.pageFive',
					{
						data : {
							pageTitle : 'Hợp đồng dự thảo'
						},
						views : {
							'partial@fileTemplate' : {
								templateUrl :  GLOBAL_URL + 'partial?uri=ga/newbusiness/filetemplate/pageFive'
							}
						}
					})
				.state(
					'fileTemplate.pageSix',
					{
						data : {
							pageTitle : 'Hợp đồng dự thảo'
						},
						views : {
							'partial@fileTemplate' : {
								templateUrl :  GLOBAL_URL + 'partial?uri=ga/newbusiness/filetemplate/pageSix'
							}
						}
					})
				.state(
					'fileTemplate.pageSeven',
					{
						data : {
							pageTitle : 'Hợp đồng dự thảo'
						},
						views : {
							'partial@fileTemplate' : {
								templateUrl :  GLOBAL_URL + 'partial?uri=ga/newbusiness/filetemplate/pageSeven'
							}
						}
					})
				.state(
					'fileTemplate.pageEight',
					{
						data : {
							pageTitle : 'Hợp đồng dự thảo'
						},
						views : {
							'partial@fileTemplate' : {
								templateUrl :  GLOBAL_URL + 'partial?uri=ga/newbusiness/filetemplate/pageEight'
							}
						}
					})
				.state(
					'fileTemplate.pageNine',
					{
						data : {
							pageTitle : 'Hợp đồng dự thảo'
						},
						views : {
							'partial@fileTemplate' : {
								templateUrl :  GLOBAL_URL + 'partial?uri=ga/newbusiness/filetemplate/pageNine'
							}
						}
					})
				.state(
					'fileTemplate.pageTen',
					{
						data : {
							pageTitle : 'Sản phẩm Liberty'
						},
						views : {
							'partial@fileTemplate' : {
								templateUrl :  GLOBAL_URL + 'partial?uri=ga/newbusiness/filetemplate/pageTen'
							}
						}
					});
		}

	}
})();
